import { replaceInitialValuesAndDates } from 'utils/tinyMCE/replaceInitialValues'
import { caseDetailSpan } from '.'
import startCase from 'lodash/startCase'
import { insertTemplate } from '../insertMenu/insertTemplate'

export const handleString = (
  editor,
  caseDetails,
  key,
  templates,
  dateFormat,
  label,
  selectedTheme,
  pageSetLocale,
  htmlValues = {},
) => {
  const content = replaceInitialValuesAndDates(
    caseDetailSpan(key, selectedTheme, editor),
    caseDetails,
    dateFormat,
    pageSetLocale,
    htmlValues,
  )
  templates.push({
    type: 'menuitem',
    text: label ?? `${startCase(key)}`,
    onAction: () => insertTemplate(editor, content),
  })
}

export default handleString
